<template>
  <div class="container-selfservice-main">
    <!--
    <DashboardCarousel
      :show-actions="false"
      @clicked-modal-create="openModalCreate"
    />
  -->
    <DashboardCardlist />
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

import DashboardCardlist from '@/components/domains/self-service/dashboard/DashboardCardlist.vue';

const isVisibleModalCreate = ref<boolean>(false);

// 새로운 통역 만들기 모달 닫기
const openModalCreate = () => {
  isVisibleModalCreate.value = true;
};
</script>

<style lang="scss" scoped></style>
